import localforage from 'localforage'

export default async function () {
  const instance = localforage.createInstance({
    driver: localforage.INDEXEDDB,
    name: 'KATalogMobile',
    version: 1.0,
    storeName: 'keyvaluepairs', // Should be alphanumeric, with underscores.
    description: 'an IndexedDB to store Tokens and keys',
  })
  
  const keys = [
    process.env.VUE_APP_LANGUAGE_STORE_KEY,
    process.env.VUE_APP_AUTH_TOKEN_STORAGE_KEY,
    'userEmail',
    'deviceUUID',
  ]
  
  for (const key of keys) {
    let stored = localStorage.getItem(key)
    if (stored) {
      await localforage.setItem(key, stored)
      localStorage.removeItem(key)
    }
  }
  
  const stored = localStorage.getItem(
    process.env.VUE_APP_AUTO_LOGIN_AUTH_TOKEN_STORAGE_KEY)
  if (stored) {
    await localforage.setItem('saveCredentials', true)
    await localforage.setItem(process.env.VUE_APP_AUTH_TOKEN_STORAGE_KEY,
      stored)
    localStorage.removeItem(
      process.env.VUE_APP_AUTO_LOGIN_AUTH_TOKEN_STORAGE_KEY)
  }
  
  return instance
}
